/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { PublicService } from './@core/data/public/public.service';
import { NbDialogService } from '@nebular/theme';
import { ConfirmActionModalComponent } from './pages/clients/confirm-action-modal/confirm-action-modal.component';
import { Store } from '@ngrx/store';
import { IAppState } from './store/app.state';
import { VatsRequested } from './store/vats/vats.actions';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  appVersion = null;
  private intervalId = null;

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private publicService: PublicService,
    private dialogService: NbDialogService,
    private store: Store<IAppState>,
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(VatsRequested());
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.handleAppVersion();
    this.listenForAccountSwitchReload();
    if (localStorage.getItem('fromAdmin') === 'true') {
      localStorage.setItem('fromAdmin', 'false');
      window.location.reload();
    }
  }

  listenForAccountSwitchReload() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'clientToken' && window.location.pathname.includes('/client/')) {
        window.location.reload();
      }
    });
  }

  updateAppVersion(version) {
    this.appVersion = version;
    localStorage.setItem('appVersion', this.appVersion);
  }

  handleAppVersion() {
    this.appVersion = localStorage.getItem('appVersion');
    const hadStoredVersion = !!this.appVersion;
    this.publicService.getAppVersion().subscribe((res: any) => {
      if (!res?.value || res.value === this.appVersion) {
        return;
      }
      this.updateAppVersion(res.value);
      if (hadStoredVersion) {
        this.clearCacheAndRefresh();
      }
    });
    this.startMonitoringAppVersion();
  }

  startMonitoringAppVersion() {
    this.startInterval();
  }

  startInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {this.subscribeToAppVersion()}, 5*60*1000)
  }

  subscribeToAppVersion() {
    this.publicService.getAppVersion().subscribe((res: any) => {
      if (res?.value && res.value !== '' && res.value !== this.appVersion) {
        clearInterval(this.intervalId);
        this.intervalId = null;

        this.dialogService.open(ConfirmActionModalComponent, {
          context: {
            title: 'Există o nouă versiune a aplicației',
            description: 'Doriți să actualizați acum? Apasați (NU) dacă doriți să amănați acestă actualizare încă 5 minute',
            isWarning: false,
            withConsent: false
          }
        }).onClose.subscribe((confirmed) => {
          if (confirmed) {
            this.updateAppVersion(res?.value);
            this.clearCacheAndRefresh();
          }
          this.startInterval();
        })
      }
    });
  }

  async clearCacheAndRefresh() {
    const cacheNames = await caches.keys();

    for (const cacheName of cacheNames) {
      await caches.delete(cacheName);
    }

    window.location.reload();
  }
}
